import type { SentencePart } from "./model";

/**
 * A sentence built from a template (`fillParts`) with its figures — walls,
 * measures, what the sheet shows — in the mono face (CI §4: every measure,
 * every ID). The words around them stay in the UI face.
 */
export function Sentence({ parts }: { parts: readonly SentencePart[] }) {
  return (
    <>
      {parts.map((part, index) =>
        typeof part === "string" ? (
          part
        ) : (
          <span key={index} className="num">
            {part.figure}
          </span>
        ),
      )}
    </>
  );
}
